module.exports = __webpack_public_path__ + "img/accounting-voucher-list.d53d2b41.svg";